import React from 'react';
import { createProjectSteps } from './createProject.tutorial';
import { projectSteps } from './project.tutorial';
import { settingsSteps } from './settings.tutorial';
import { Splash } from './Splash';
import { CustomStep } from './Tutorial';

export const indexSteps = (): CustomStep[] => {
  const steps: CustomStep[] = [
    {
      content: <Splash />,
      placement: 'center',
      target: 'body',
      disableBeacon: true,
      floaterProps: {
        styles: {
          floater: {
            width: '850px',
            maxWidth: '95%',
            marginRight: 'auto',
            marginLeft: 'auto',
          },
        },
      },
      styles: {
        tooltip: {
          fontSize: '2vw',
          lineHeight: '2.5vw',
          width: '100%',
        },
      },
    },
    {
      content: 'This is where your projects will appear',
      target: '#side-menu-tab-0',
      placement: 'auto',
      disableBeacon: true,
      disableScrolling: true,
    },
    {
      content:
        'This is where your items will appear. Items refer to your tasks, coordinations, and events across all projects.',
      target: '#side-menu-tab-1',
      placement: 'auto',
      disableBeacon: true,
    },
    // {
    //   content:
    //     "You can filter between just your projects and your entire organization's projects here",
    //   target: '#filter-0-1',
    //   placement: 'auto',
    //   disableBeacon: true,
    // },
    {
      content: 'You can access inactive and archived projects here',
      target: '#side-menu-tab-3',
      placement: 'auto',
      disableBeacon: true,
    },
    {
      content: 'Edit your Login Details',
      target: '#headershort-icon-1',
      placement: 'auto',
    },
    {
      content: 'Manage your Account',
      target: '#headershort-icon-0',
      placement: 'auto',
      disableBeacon: true,
    },
    ...settingsSteps(),
    {
      content: 'Create a New Project',
      target: '#tab-index-table-speeddial',
      placement: 'auto',
      disableBeacon: true,
    },
    ...createProjectSteps(),
    {
      content:
        "Projects are listed here. Click to navigate to a project's page to access the project plan, schedule, and files.",
      target: '#index-table',
      placement: 'auto',
      disableBeacon: true,
    },
    ...projectSteps(),
  ];
  return steps;
};
